import { createActionConst } from '../../../utils/action.utils';

const PASSWORD_NAMESPACE = 'PASSWORD';

export const SEARCH_PASSWORDS = createActionConst(PASSWORD_NAMESPACE, 'SEARCH_PASSWORDS');

export const STORE_PASSWORD = createActionConst(PASSWORD_NAMESPACE, 'STORE_PASSWORD');
export const CLEAR_PASSWORD = createActionConst(PASSWORD_NAMESPACE, 'CLEAR_PASSWORD');
